import { Injectable } from '@angular/core';

/** End of day (23:59:59.999) for a Date or Firestore Timestamp; falsy values pass through. */
export function endOfDay<T>(value: T): T | Date {
  if (!value) return value;
  const v: any = value;
  const d = new Date(typeof v.toDate === 'function' ? v.toDate() : v);
  d.setHours(23, 59, 59, 999);
  return d;
}

@Injectable({
  providedIn: 'root'
})
export class DateRangeFormatService {

  /** Start of day: 00:00:00.000 */
  startOfDay(date: Date | null): Date | null {
    if (!date) return null;

    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  /** End of day: 23:59:59.999 */
  endOfDay(date: Date | null): Date | null {
    if (!date) return null;

    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  /** Normalize a date range */
  normalizeRange(start: Date | null, end: Date | null) {
    return {
      startDate: this.startOfDay(start),
      endDate: this.endOfDay(end)
    };
  }
}
